import { defineMessages, useIntl } from 'react-intl'
import BotHead from '../Avatar/BotHeadColored'
import { Panel } from '../..'
import { Heading, Text } from '@homebot/shared-ui-swashbuckle'
import { CustomerProfile } from '../../../types/customerProfile'
import styles from './EstimatedValueZeroState.module.scss'

const MSG = defineMessages({
  whatsYourHomeWorth: {
    id: 'Homeowner.estimatedValue.zeroState',
    defaultMessage: "What's your home worth?",
  },
  trouble: {
    id: 'Homeowner.estimatedValue.zeroState.trouble',
    defaultMessage:
      "We're having a little trouble gathering enough data to calculate an accurate value",
  },
  notified: {
    id: 'Homeowner.estimatedValue.zeroState.notifiedNewKey',
    defaultMessage:
      "Don't worry, {firstName} is on the case! {firstName} has been notified and we'll get to the work on resolving your home details!",
  },
})

interface EstimatedValueZeroStateProps {
  customerProfile: CustomerProfile
}

export const EstimatedValueZeroState = ({
  customerProfile,
}: EstimatedValueZeroStateProps) => {
  const intl = useIntl()
  return (
    <Panel data-qa='EstimatedValueZeroState' className={styles.container}>
      <Heading fontWeight='semibold' size='xl' className={styles.heading}>
        {intl.formatMessage(MSG.whatsYourHomeWorth)}
      </Heading>
      <div className={styles.messagingContainer}>
        <div className={styles.peekTop}>
          <BotHead quizzical type='danger' className={styles.peekTopAvatar} />
        </div>
        <Text color='text.heading' size='md' marginBottom='spacing-200'>
          {intl.formatMessage(MSG.trouble)}
        </Text>
        <Text size='sm'>
          {intl.formatMessage(MSG.notified, {
            firstName: customerProfile.firstName,
          })}
        </Text>
      </div>
    </Panel>
  )
}
